<template>
  <main class="page-operative page-operative-project page-operative-project-library-templates page-operative-project-library-templates-list d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-start justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Modelli di progetto (libreria)</PageTitle>

        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.projects.library.templates.add' }">
          Aggiungi modello di progetto (libreria)
        </app-router-link>
      </div>

      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <ProjectLibraryTemplatesListTable v-if="results" class="report-texts-size" :templates="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeTemplate" />
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';
import loadingDataMixin from '@/mixins/loadingData';
import confirmWithModalMixin from '@/libs/Confirm/mixins/confirmWithModal';

export default {
  name: 'page-operative-company-project-library-templates-list',
  mixins: [operativePageMixin, loadingDataMixin, confirmWithModalMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('@/views/components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('@/views/components/Operative/LoadingDataLoader'),
    ProjectLibraryTemplatesListTable: () => import('@/views/components/Operative/ListTable/ProjectLibraryTemplatesListTable'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  data () {
    return {
      data: null,
      results: null,
    };
  },
  methods: {
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.listProjectLibraryTemplates(this.company?.id)
        .then(res => {
          this.results = res?.data?.templates || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeTemplate (id) {
      this.confirm('Cancellare il modello di progetto (libreria) selezionato? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteProjectLibraryTemplate(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.retrieveListData();
      },
    },
  },
};

</script>
